export const countries = [
  { label: "Afghanistan (+11)", value: "11" },
  { label: "Albania (+355)", value: "355" },
  { label: "Algeria (+213)", value: "213" },
  { label: "American Samoa (+1)", value: "1" },
  { label: "Angola (+244)", value: "244" },
  { label: "Argentina (+54)", value: "54" },
  { label: "Australia (+61)", value: "61" },
  { label: "Austria (+43)", value: "43" },
  { label: "Azerbaijan (+994)", value: "994" },
  { label: "Bahamas (+1242)", value: "1242" },
  { label: "Bangladesh (+880)", value: "880" },
  { label: "Barbados (+1246)", value: "1246" },
  { label: "Belarus (+375)", value: "375" },
  { label: "Belgium (+32)", value: "32" },
  { label: "Benin (+229)", value: "229" },
  { label: "Bermuda (+1441)", value: "1441" },
  { label: "Bhutan (+975)", value: "975" },
  { label: "Bolivia (+591)", value: "591" },
  { label: "Bosnia and Herzegovina (+387)", value: "387" },
  { label: "Botswana (+267)", value: "267" },
  { label: "Brazil (+55)", value: "55" },
  { label: "Brunei (+673)", value: "673" },
  { label: "Bulgaria (+359)", value: "359" },
  { label: "Burkina Faso (+226)", value: "226" },
  { label: "Burundi (+257)", value: "257" },
  { label: "Cambodia (+855)", value: "855" },
  { label: "Cameroon (+237)", value: "237" },
  { label: "Canada (+1)", value: "1" },
  { label: "Cape Verde (+238)", value: "238" },
  { label: "Central African Republic (+236)", value: "236" },
  { label: "Chad (+235)", value: "235" },
  { label: "Chile (+56)", value: "56" },
  { label: "China (+86)", value: "86" },
  { label: "Colombia (+57)", value: "57" },
  { label: "Comoros (+269)", value: "269" },
  { label: "Congo (+242)", value: "242" },
  { label: "Congo, Republic (+243)", value: "243" },
  { label: "Costa Rica (+506)", value: "506" },
  { label: "Cote d'Ivoire (+225)", value: "225" },
  { label: "Croatia (+385)", value: "385" },
  { label: "Cuba (+53)", value: "53" },
  { label: "Cyprus (+357)", value: "357" },
  { label: "Czech Republic (+420)", value: "420" },
  { label: "Denmark (+45)", value: "45" },
  { label: "Djibouti (+253)", value: "253" },
  { label: "Dominican Republic (+1809)", value: "1809" },
  { label: "Ecuador (+593)", value: "593" },
  { label: "Egypt (+20)", value: "20" },
  { label: "EL Salvador (+503)", value: "503" },
  { label: "Equatorial Guinea (+240)", value: "240" },
  { label: "Eritrea (+291)", value: "291" },
  { label: "Estonia (+372)", value: "372" },
  { label: "Ethiopia (+251)", value: "251" },
  { label: "Fiji (+679)", value: "679" },
  { label: "Finland (+358)", value: "358" },
  { label: "France (+33)", value: "33" },
  { label: "French Polynesia (+689)", value: "689" },
  { label: "Gabon (+241)", value: "241" },
  { label: "Gambia (+220)", value: "220" },
  { label: "Georgia (+995)", value: "995" },
  { label: "Germany (+49)", value: "49" },
  { label: "Ghana (+233)", value: "233" },
  { label: "Greece (+30)", value: "30" },
  { label: "Grenada (+1473)", value: "1473" },
  { label: "Guam (+1671)", value: "1671" },
  { label: "Guatemala (+502)", value: "502" },
  { label: "Guinea (+224)", value: "224" },
  { label: "Guinea Bissau (+245)", value: "245" },
  { label: "Guyana (+592)", value: "592" },
  { label: "Haiti (+509)", value: "509" },
  { label: "Honduras (+504)", value: "504" },
  { label: "Hong Kong (+852)", value: "852" },
  { label: "Hungary (+36)", value: "36" },
  { label: "Iceland (+354)", value: "354" },
  { label: "India (+91)", value: "91" },
  { label: "Indonesia (+62)", value: "62" },
  { label: "Iran (+98)", value: "98" },
  { label: "Iraq (+964)", value: "964" },
  { label: "Ireland (+353)", value: "353" },
  { label: "Israel (+972)", value: "972" },
  { label: "Italy (+39)", value: "39" },
  { label: "Jamaica (+1876)", value: "1876" },
  { label: "Japan (+81)", value: "81" },
  { label: "Jordan (+962)", value: "962" },
  { label: "Kenya (+254)", value: "254" },
  { label: "Kiribati (+686)", value: "686" },
  { label: "Kuwait (+965)", value: "965" },
  { label: "Laos (+856)", value: "856" },
  { label: "Latvia (+371)", value: "371" },
  { label: "Lebanon (+961)", value: "961" },
  { label: "Lesotho (+266)", value: "266" },
  { label: "Liberia (+231)", value: "231" },
  { label: "Libya (+218)", value: "218" },
  { label: "Lithuania (+370)", value: "370" },
  { label: "Luxembourg (+352)", value: "352" },
  { label: "Macedonia (+389)", value: "389" },
  { label: "Madagascar (+261)", value: "261" },
  { label: "Malawi (+265)", value: "265" },
  { label: "Malaysia (+60)", value: "60" },
  { label: "Malaysia (+60)", value: "60" },
  { label: "Maldives (+960)", value: "960" },
  { label: "Mali (+223)", value: "223" },
  { label: "Malta (+356)", value: "356" },
  { label: "Mauritania (+222)", value: "222" },
  { label: "Mauritius (+230)", value: "230" },
  { label: "Mexico (+52)", value: "52" },
  { label: "Micronesia (+691)", value: "691" },
  { label: "Mongolia (+976)", value: "976" },
  { label: "Montenegro (+382)", value: "382" },
  { label: "Morocco (+212)", value: "212" },
  { label: "Mozambique (+258)", value: "258" },
  { label: "Namibia (+264)", value: "264" },
  { label: "Nauru (+674)", value: "674" },
  { label: "Nepal (+977)", value: "977" },
  { label: "Netherlands (+31)", value: "31" },
  { label: "New Caledonia (+687)", value: "687" },
  { label: "New Zealand (+64)", value: "64" },
  { label: "Nicaragua (+505)", value: "505" },
  { label: "Niger (+227)", value: "227" },
  { label: 'Nigeria (+234)', value: '234' },
  { label: "Niue (+683)", value: "683" },
  { label: "North Korea (+850)", value: "850" },
  { label: "Northern Mariana (+1670)", value: "1670" },
  { label: "Norway (+47)", value: "47" },
  { label: "Oman (+968)", value: "968" },
  { label: "Pakistan (+92)", value: "92" },
  { label: "Palau (+680)", value: "680" },
  { label: "Panama (+507)", value: "507" },
  { label: "Papua New Guinea (+675)", value: "675" },
  { label: "Paraguay (+595)", value: "595" },
  { label: "Peru (+51)", value: "51" },
  { label: "Philippines (+63)", value: "63" },
  { label: "Pitcairn (+870)", value: "870" },
  { label: "Poland (+48)", value: "48" },
  { label: "Portugal (+351)", value: "351" },
  { label: "Puerto Rico (+1)", value: "1" },
  { label: "Qatar (+974)", value: "974" },
  { label: "Romania (+40)", value: "40" },
  { label: "Russia (+7)", value: "7" },
  { label: "Rwanda (+250)", value: "250" },
  { label: "Samoa (+685)", value: "685" },
  { label: "Sao Tome & Principe (+239)", value: "239" },
  { label: "Saudi Arabia (+966)", value: "966" },
  { label: "Senegal (+221)", value: "221" },
  { label: "Serbia (+381)", value: "381" },
  { label: "Seychelles (+248)", value: "248" },
  { label: "Sierra Leone (+232)", value: "232" },
  { label: "Singapore (+65)", value: "65" },
  { label: "Slovakia (+421)", value: "421" },
  { label: "Slovenia (+386)", value: "386" },
  { label: "Solomon Islands (+677)", value: "677" },
  { label: "Somalia (+252)", value: "252" },
  { label: "South Africa (+27)", value: "27" },
  { label: "South Korea (+82)", value: "82" },
  { label: "South Sudan (+211)", value: "211" },
  { label: "Spain (+34)", value: "34" },
  { label: "Sri Lanka (+94)", value: "94" },
  { label: "Sudan (+249)", value: "249" },
  { label: "Swaziland (+41)", value: "41" },
  { label: "Sweden (+46)", value: "46" },
  { label: "Switzerland (+268)", value: "268" },
  { label: "Syria (+963)", value: "963" },
  { label: "Taiwan (+886)", value: "886" },
  { label: "Tajikistan (+992)", value: "992" },
  { label: "Tanzania (+255)", value: "255" },
  { label: "Thailand (+66)", value: "66" },
  { label: "Timor-Leste (+670)", value: "670" },
  { label: "Togo (+228)", value: "228" },
  { label: "Tonga (+676)", value: "676" },
  { label: "Trinidad & Tobago (+1868)", value: "1868" },
  { label: "Tunisia (+216)", value: "216" },
  { label: "Turkey (+90)", value: "90" },
  { label: "Tuvalu (+688)", value: "688" },
  { label: "Uganda (+256)", value: "256" },
  { label: "Ukraine (+380)", value: "380" },
  { label: "United Arab Emirates (+971)", value: "971" },
  { label: "United Kingdom (+44)", value: "44" },
  { label: "United States (+1)", value: "1" },
  { label: "Uruguay (+598)", value: "598" },
  { label: "Uzbekistan (+998)", value: "998" },
  { label: "Vanuatu (+678)", value: "678" },
  { label: "Venezuela (+58)", value: "58" },
  { label: "Vietnam (+84)", value: "84" },
  { label: "Virgin Islands (+1)", value: "1" },
  { label: "Western Sahara (+212)", value: "212" },
  { label: "Yemen (+967)", value: "967" },
  { label: "Zambia (+260)", value: "260" },
  { label: "Zimbabwe (+263)", value: "263" }
];

export const timeZones = [
  { value: 1, label: 'Line Islands Time (+14.00)' },
  { value: 2, label: 'Phoenix Island Time (+13.00)' },
  { value: 3, label: 'Tokelau Time (+13.00)' },
  { value: 4, label: 'West Samoa Time (+13.00)' },
  { value: 5, label: 'Chatham Island (+12.45)' },
  { value: 6, label: 'Anadyr Time (+12.00)' },
  { value: 7, label: 'Fiji Time (+12.00)' },
  { value: 8, label: 'Gilbert Island Time (+12.00)' },
  { value: 9, label: 'Magadan Time (+12.00)' },
  { value: 10, label: 'Marshall Islands Time (+12.00)' },
  { value: 11, label: 'New Zealand Standard Time (+12.00)' },
  { value: 12, label: 'Kamchatka Time (+12.00)' },
  { value: 13, label: 'Tuvalu Time (+12.00)' },
  { value: 14, label: 'Wallis and Futuna Time (+12.00)' },
  { value: 15, label: 'Norfolk Time (+11.30)' },
  { value: 16, label: 'New Caledonia Time (+11.00)' },
  { value: 17, label: 'Pohnpei Standard Time (+11.00)' },
  { value: 18, label: 'Solomon Islands Time (+11.00)' },
  { value: 19, label: 'Vladivostok Time (+11.00)' },
  { value: 20, label: 'Vanuatu Time (+11.00)' },
  { value: 21, label: 'Lord Howe Standard Time (+10.30)' },
  { value: 22, label: 'Australian Eastern Standard Time (+10.00)' },
  { value: 23, label: 'Chamorro Standard Time (+10.00)' },
  { value: 24, label: 'Papua New Guinea Time (+10.00)' },
  { value: 25, label: 'Yakutsk Time (+10.00)' },
  { value: 26, label: 'Yap Time (+10.00)' },
  { value: 27, label: 'Australian Central Standard Time (+9.30)' },
  { value: 28, label: 'Irkutsk Time (+9.00)' },
  { value: 29, label: 'Japan Standard Time (+9.00)' },
  { value: 30, label: 'Korea Standard Time (+9.00)' },
  { value: 31, label: 'Palau Time Pacific (+9.00)' },
  { value: 32, label: 'East Timor Time (+9.00)' },
  { value: 33, label: 'Eastern Indonesian Time (+9.00)' },
  { value: 34, label: 'China Standard Time (+8.00)' },
  { value: 35, label: 'Australian Western Standard Time (+8.00)' },
  { value: 36, label: 'Brunei Darussalam Time (+8.00)' },
  { value: 37, label: 'Hong Kong Time (+8.00)' },
  { value: 38, label: 'Krasnoyarsk Time (+8.00)' },
  { value: 39, label: 'Philippine Time (+8.00)' },
  { value: 40, label: 'Singapore Time (+8.00)' },
  { value: 41, label: 'Ulaanbaatar Time (+8.00)' },
  { value: 42, label: 'Malaysia Time (+8.00)' },
  { value: 43, label: 'Central Indonesian Time (+8.00)' },
  { value: 44, label: 'Christmas Island Time (+7.00)' },
  { value: 45, label: 'Hovd Time (+7.00)' },
  { value: 46, label: 'Indochina Time (+7.00)' },
  { value: 47, label: 'Omsk Standard Time (+7.00)' },
  { value: 48, label: 'Western Indonesian Time (+7.00)' },
  { value: 49, label: 'Myanmar Time (+6.30)' },
  { value: 50, label: 'Cocos Islands Time (+6.30)' },
  { value: 51, label: 'Bangladesh Standard Time (+6.00)' },
  { value: 52, label: 'Bhutan Time (+6.00)' },
  { value: 53, label: 'Alma-Ata Time (+6.00)' },
  { value: 54, label: 'Novosibirsk Time (+6.00)' },
  { value: 55, label: 'Kyrgyzstan Time (+6.00)' },
  { value: 56, label: 'Yekaterinburg Time (+6.00)' },
  { value: 57, label: 'Nepal Time (+6.00)' },
  { value: 58, label: 'India Standard Time (+5.30)' },
  { value: 59, label: 'Pakistan Standard Time (+5.00)' },
  { value: 60, label: 'Tajikistan Time (+5.00)' },
  { value: 61, label: 'Turkmenistan Time (+5.00)' },
  { value: 62, label: 'Uzbekistan Time (+5.00)' },
  { value: 63, label: 'Maldives Time (+5.00)' },
  { value: 64, label: 'Afghanistan Time (+4.30)' },
  { value: 65, label: 'Seychelles Time (+4.00)' },
  { value: 66, label: 'Armenia Time (+4.00)' },
  { value: 67, label: 'Azerbaijan Time (+4.00)' },
  { value: 68, label: 'Georgia Standard Time (+4.00)' },
  { value: 69, label: 'Gulf Standard Time (+4.00)' },
  { value: 70, label: 'Kuybyshev Time (+4.00)' },
  { value: 71, label: 'Moscow Standard Time (+4.00)' },
  { value: 72, label: 'Mauritius Time (+4.00)' },
  { value: 73, label: 'Samara Time (+4.00)' },
  { value: 74, label: 'Iran Standard Time (+3.30)' },
  { value: 75, label: 'East Africa Time (+3.00)' },
  { value: 76, label: 'Arabia Standard Time (+3.00)' },
  { value: 77, label: 'Central Africa Time (+2.00)' },
  { value: 78, label: 'Eastern European Time (+2.00)' },
  { value: 79, label: 'Israel Standard Time (+2.00)' },
  { value: 80, label: 'South Africa Standard Time (+2.00)' },
  { value: 81, label: 'Central European Time (+1.00)' },
  { value: 82, label: 'Irish Standard Time (+1.00)' },
  { value: 83, label: 'West Africa Time (+1.00)' },
  { value: 84, label: 'Greenwich Mean Time (00)' },
  { value: 85, label: 'Cape Verde Time (-1.00)' },
  { value: 86, label: 'Fernando de Noronha Time (-2.00)' },
  { value: 87, label: 'Brasília Time (-3.00)' },
  { value: 88, label: 'Argentina Time (-3.00)' },
  { value: 89, label: 'French Guiana Time (-3.00)' },
  { value: 90, label: 'Pierre & Miquelon Standard Time (-3.00)' },
  { value: 91, label: 'Bolivia Time (-4.00)' },
  { value: 92, label: 'Atlantic Standard Time (-4.00)' },
  { value: 93, label: 'Amazon Time (-4.00)' },
  { value: 94, label: 'Atlantic Standard Time (-4.00)' },
  { value: 95, label: 'Falkland Island Time (-4.00)' },
  { value: 96, label: 'Guyana Time (-4.00)' },
  { value: 97, label: 'Paraguay Time (-4.00)' },
  { value: 98, label: 'Chile Standard Time (-4.00)' },
  { value: 99, label: 'Venezuelan Standard Time (-4.00)' },
  { value: 100, label: 'Eastern Standard Time (-5.00)' },
  { value: 101, label: 'Ecuador Time (-5.00)' },
  { value: 102, label: 'Cuba Standard Time (-5.00)' },
  { value: 103, label: 'Colombia Time (-5.00)' },
  { value: 104, label: 'Peru Time (-5.00)' },
  { value: 105, label: 'Central Standard Time (-6.00)' },
  { value: 106, label: 'Mountain Time (-7.00)' },
  { value: 107, label: 'Pacific Standard Time (-8.00)' },
  { value: 108, label: 'Alaska Standard Time (-9.00)' },
  { value: 109, label: 'Marquesas Time (-9.30)' },
  { value: 110, label: 'Tahiti Time (-10.00)' },
  { value: 111, label: 'Hawaii-Aleutian Standard Time (-10.00)' },
  { value: 112, label: 'Cook Island Time (-10.00)' },
  { value: 113, label: 'Niue Time (-11.00)' },
  { value: 114, label: 'Samoa Standard Time (-11.00)' },
  { value: 115, label: 'Baker Time (-12.00)' },
];

export const accountTypes = ['Personal', 'Corporate', 'Internal'];

export const globalVals = {
  userTypePersonal: 1,
  userTypeCorporate: 2,
  genderMale: 1,
  genderFemale: 2,
};

export const extensibleTypes = {
  text: 'text',
  image: 'image',
  audio: 'audio',
  video: 'video',
  vote: 'vote',
  survey: 'survey',
  poll: 'poll',
};

export const featureIntros = [
  {
    title: 'Birthday Messaging Automation',
    description:
      'Automate your birthday messaging like banks and be the first to wish your family members, friends, loved ones, customers, group members, etc, a happy birthday on their special days. Count on Zigatext as it delivers that your lovely and heart warming message very early in the morning for you to that special one.',
  },
  {
    title: 'SMS Newsletter for schools',
    description:
      'Boost awareness and trust, reach students faster with SMS messaging (one of the most reliable means of communication) for FREE. Send SMS Newsletters frequently to your students to keep them informed. It can be used by course reps - for change of lecture venue alerts; class reps, departments, faculties and the institution at large for reliable urgent information discemination.',
  },
  {
    title: 'SMS Newsletter for religious bodies',
    description:
      'Send scriptural verses, or morning devotional messages to your members every day for FREE',
  },
  {
    title: 'SMS Newsletter for NGOs',
    description:
      'Send awareness campaign SMSes to your subscribers occationally or periodically to keep them always upto date for FREE.',
  },
  {
    title: 'SMS Newsletter for content publishers',
    description:
      "Are you a professional with wealth of knowledge in your area of specialization? Are you willing to be sharing the knowledge while making money on the process? If your answer is yes to the questions, you're about to redefine your financial status, you just need to start a paid SMS Newsletter on Zigatext, grow your subscribers base and watch your finance soar while doing what you love: sharing. ",
  },
  {
    title: 'Zigatext affiliate membership programme',
    description:
      'Affiliate Membership – A home business you can do at your free time to make additional income without quitting your current job. As an affiliate member you can be earning upto 25% life time residual commission by just recommending Zigatext to people and any time they buy units you get your commission.',
  },
  {
    title: 'Zigatext agent partnership programme',
    description:
      "Partnering with us as an agent qualifies you to reseller Ziga Units and make massive profit in this digital gold mine (just like selling network operators airtime, data, paytv subscriptions etc). SMS business is a multi billion dollar industry and with Zigatext you don't have to create and maintian your own website to resell SMS units, Zigatext takes care of all the technicalities for you. To become our agent you can contact us through our support channels.",
  },
  {
    title: 'Schedules with Recurrence or multi-time delivery',
    description:
      'What this means is that you can schedule a massage that can send by 1pm today and tomorrow it will send by 9am next it will send by 12am. Recurrence functionality enables you to schedule message that can be sending at a particular time, everyday, week, month or year.',
  },
  {
    title: "Zigatext's SMS message Tagging",
    description:
      'SMS Tagging allows personalization of bulk SMS to individuals like addressing each recipient by name, etc. You send bulk SMS and every recipient will have the SMS delivered in his or her inbox with his name on the message.',
  },
  {
    title: 'Schedule and SMS collections with random-time delivery',
    description:
      'This schedule functionality enables you to pick an sms collection group like Romance and be sending messages from that collection to your recipient(s). You can decide to be sending "I love you" SMS to your wife, sending it at a particular time of the day may not be romantic enough but the SMS coming unexpectedly or randomly will make more sense.',
  },
  {
    title: 'Capture SMS Newsletter subscribers from your Websites',
    description:
      'As a website owner you can capture phone numbers and names of your website visitors and automatically subscribe them to particular SMS Newsletter list for future follow ups with messages.',
  },
  {
    title: 'Capture Birthday contacts from your websites/systems',
    description:
      'If your website or app captures audience birthdays you can add them directly to your Zigatext birthday messenger group for future birthday messaging.',
  },
  {
    title: "Zigatext's SMS collections",
    description:
      '1000s of SMSs grouped by type, like Birthday, romance, Business, I Love you etc.',
  },
];

export const monthNames = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];
